var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-org" }, [
    _c(
      "div",
      { staticClass: "org-top" },
      [
        _c(
          "el-form",
          {
            staticClass: "demo-form-inline",
            attrs: { inline: true, model: _vm.formInline }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "机构名称:" } },
              [
                _c("el-input", {
                  staticStyle: { width: "220px" },
                  attrs: { size: "small", placeholder: "请输入机构名称" },
                  model: {
                    value: _vm.formInline.orgName,
                    callback: function($$v) {
                      _vm.$set(_vm.formInline, "orgName", $$v)
                    },
                    expression: "formInline.orgName"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "机构编号:" } },
              [
                _c("el-input", {
                  staticStyle: { width: "220px" },
                  attrs: { size: "small", placeholder: "请输入机构名称" },
                  model: {
                    value: _vm.formInline.orgNun,
                    callback: function($$v) {
                      _vm.$set(_vm.formInline, "orgNun", $$v)
                    },
                    expression: "formInline.orgNun"
                  }
                })
              ],
              1
            ),
            _c("el-form-item", { staticClass: "operate-btn" }, [
              _c("input", {
                staticClass: "btn btn-red search-btn",
                attrs: { type: "button", value: "查询" },
                on: { click: _vm.searchFn }
              })
            ])
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "org-body" }, [
      _c("div", { staticClass: "org-left" }, [
        _c("div", { staticClass: "org-title" }, [_vm._v("可选机构列表")]),
        _c(
          "div",
          { staticClass: "dep-tree" },
          [
            _c("el-tree", {
              attrs: { data: _vm.data, props: _vm.defaultProps }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "org-right" },
        [
          _c("div", { staticClass: "org-title" }, [_vm._v("已选机构列表")]),
          _vm._l(_vm.selectdData, function(item, i) {
            return _c("div", { key: i, staticClass: "selectd-org" }, [
              _vm._v(" " + _vm._s(item.title) + " "),
              _c("i", { staticClass: "del-org", on: { click: _vm.delOrgFn } })
            ])
          })
        ],
        2
      )
    ]),
    _c("div", { staticClass: "dialog-footer" }, [
      _c("input", {
        staticClass: "btn",
        attrs: { type: "button", value: "取消" },
        on: { click: _vm.cancelFn }
      }),
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { type: "button", value: "确认" },
        on: { click: _vm.commitFn }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }